import {LogLevel} from './logLevel';
import {LogSourceType} from './logSourceType';

export class LogMessage {
  level: LogLevel;
  sourceType: LogSourceType;
  source: string;
  message: string;
  time: Date;
  content: any;
  hash: string;

  constructor(level: LogLevel, sourceType: LogSourceType, source: string, message: string, content?: any) {
    this.content = content;
    this.level = level;
    this.sourceType = sourceType;
    this.source = source;
    this.message = message;
    this.time = new Date();
  }
}
